var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.1417L9.7075 -5.6497e-08L5.5 3.7085L1.2925 -4.24328e-07L-4.99053e-08 1.1417L5.5 6L11 1.1417Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownActive);
export default __webpack_public_path__ + "static/media/arrow-down-active.68c8757fc17b7070b666a3d0bffedf7a.svg";
export { ForwardRef as ReactComponent };